import React from "react";
import {Col, Descriptions, Divider, Row, Tag} from "antd";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {toTurkishUpperCase} from "../../../../../utils/helpers";
import {useCourierOnboarding} from "hooks/useCourierOnboarding";
import "./CourierSummary.css";
import {experienceTypes} from "constants/constants";
export const CourierSummary = ({courier, loading}) => {
    const {t, i18n} = useTranslation([
        "onboardingStatuses",
        "onboardingSubStatuses",
        "onboardingSteps"
    ]);
    const {
        renderOnboardingStatus,
        renderOnboardingStep,
        renderOnboardingSubStatus
    } = useCourierOnboarding();
    const {
        fullname = "",
        workingType = undefined,
        cellPhone = "",
        email = "",
        city = "",
        county = "",
        neighborhood = undefined,
        preferredCity = undefined,
        preferredDistricts = [],
        address = "",
        iban = "",
        taxOffice = "",
        taxNumber = "",
        personCompany = "",
        onboardingStatus = "",
        onboardingSubStatus = "",
        onboardingStep = "",
        isApplicationRejected = false,
        onboardingRejectReason = "",
        emergencyContactName = "",
        emergencyContactPhone = "",
        emergencyContactDegree = "",
        bankName = "",
        deviceInfo = {},
        isTestUser = false,
        trained = false,
        vehicleInfo = "",
        jobStartDate = undefined,
        createdByUser = undefined,
        createdById = undefined,
        createdBy = "",
        createdAt = undefined,
        updatedBy = "",
        updatedAt = undefined,
        hasP1Certificate = undefined,
        workingModel = undefined,
        experience = undefined,
        motorType = undefined,
        vgid = undefined
    } = courier || {};
    const courierSeniority = jobStartDate => {
        const year = moment().diff(moment(jobStartDate), "years");
        const month = moment().diff(moment(jobStartDate), "months") - year * 12;
        if (jobStartDate === null) return t("noSeniorityData", {ns: "courierPage"});
        if (year === 0 && month === 0) {
            return 0 + " " + t("units.month.long", {ns: "common"});
        }
        if (year === 0) {
            return month + " " + t("units.month.long", {ns: "common"});
        }
        if (month === 0) {
            return year + " " + t("units.year.long", {ns: "common"});
        }
        return (
            year +
            " " +
            t("units.year.long", {ns: "common"}) +
            " " +
            month +
            " " +
            t("units.month.long", {ns: "common"})
        );
    };
    return loading ? (
        <>Yükleniyor...</>
    ) : (
        <>
            <Row gutter={[16, 16]} style={{marginBottom: "16px"}}>
                <Col span={24} md={24} lg={12}>
                    <Row style={{flexDirection: "column", marginBottom: "16px"}}>
                        <h3>İşe Alım Durumu</h3>
                        <Descriptions
                            bordered
                            size={"small"}
                            column={1}
                            className="courierSummaryDescriptions"
                        >
                            <Descriptions.Item label="Durumu">
                                <span style={{fontSize: "16px", fontWeight: "bold"}}>
                                    {renderOnboardingStatus({
                                        onboardingStatus,
                                        isApplicationRejected
                                    })}
                                </span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Süreçte Bulunduğu Adım">
                                <span style={{fontSize: "16px", fontWeight: "bold"}}>
                                    {renderOnboardingStep({onboardingStep})}
                                </span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Alt Durum">
                                <span style={{fontSize: "16px", fontWeight: "bold"}}>
                                    {renderOnboardingSubStatus({
                                        onboardingSubStatus,
                                        isApplicationRejected,
                                        onboardingStatus: onboardingStatus
                                    })}
                                </span>
                                {onboardingSubStatus === "documentsInReview" &&
                                !isApplicationRejected ? (
                                    <>
                                        <br />
                                        <Tag color="red" style={{whiteSpace: "normal"}}>
                                            Kurye bu adımda evrak düzenleme yapamaz
                                        </Tag>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </Descriptions.Item>
                            <Descriptions.Item label="Red Sebebi">
                                {onboardingRejectReason || "-"}
                            </Descriptions.Item>
                        </Descriptions>
                    </Row>
                    <Row style={{flexDirection: "column", marginBottom: "16px"}}>
                        <h3>İletişim Bilgileri</h3>
                        <Descriptions
                            bordered
                            size={"small"}
                            column={1}
                            className="courierSummaryDescriptions"
                        >
                            <Descriptions.Item label="Telefon">{cellPhone}</Descriptions.Item>
                            <Descriptions.Item label="E-mail">{email}</Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.emergencyContactName", {ns: "common"})}
                            >
                                {emergencyContactName}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.emergencyContactPhone", {ns: "common"})}
                            >
                                {emergencyContactPhone}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.emergencyContactDegree", {ns: "common"})}
                            >
                                {emergencyContactDegree}
                            </Descriptions.Item>
                        </Descriptions>
                    </Row>
                    <Row style={{flexDirection: "column", marginBottom: "16px"}}>
                        <h3>Şahıs Şirketi Bilgileri</h3>
                        <Descriptions
                            bordered
                            size={"small"}
                            column={1}
                            style={{border: "1px solid #e8e8e8"}}
                        >
                            <Descriptions.Item label="Şahıs Şirketi Adı">
                                {personCompany}
                            </Descriptions.Item>

                            <Descriptions.Item label="Vergi Dairesi">{taxOffice}</Descriptions.Item>
                            <Descriptions.Item label="Vergi Numarası">
                                {taxNumber}
                            </Descriptions.Item>
                            <Descriptions.Item label={t("fields.bankName", {ns: "common"})}>
                                {bankName}
                            </Descriptions.Item>
                            <Descriptions.Item label="IBAN">{iban}</Descriptions.Item>
                        </Descriptions>
                    </Row>
                </Col>
                <Col span={24} md={24} lg={12}>
                    <Row style={{flexDirection: "column", marginBottom: "16px"}}>
                        <h3>Adres Bilgileri</h3>
                        <Descriptions
                            bordered
                            size={"small"}
                            column={1}
                            className="courierSummaryDescriptions"
                        >
                            <Descriptions.Item label="Şehir">
                                {toTurkishUpperCase(city)}
                            </Descriptions.Item>
                            <Descriptions.Item label="İlçe">
                                {toTurkishUpperCase(county)}
                            </Descriptions.Item>
                            <Descriptions.Item label="Mahalle">
                                {neighborhood?.name || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Adres">{address || "-"}</Descriptions.Item>
                        </Descriptions>
                    </Row>
                    <Row style={{flexDirection: "column", marginBottom: "16px"}}>
                        <h3>Çalışma Bilgileri</h3>
                        <Descriptions
                            bordered
                            size={"small"}
                            column={1}
                            className="courierSummaryDescriptions"
                        >
                            <Descriptions.Item label="Çalışma Modeli">
                                {workingType?.label?.tr || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Çalışma Zamanı">
                                {workingModel?.label?.tr || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Çalışmak İstenen Şehir">
                                {preferredCity?.name || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Çalışmak İstenen İlçeler">
                                {preferredDistricts?.map(district => district?.name)?.join(", ") ||
                                    "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Kuryelik Deneyimi">
                                {experienceTypes[experience]?.tr || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Motor Tipi">
                                {motorType?.label?.tr || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="P1* Belgesi Durumu">
                                {typeof hasP1Certificate === "boolean"
                                    ? hasP1Certificate
                                        ? "Var"
                                        : "Yok"
                                    : "-"}
                            </Descriptions.Item>
                        </Descriptions>
                    </Row>
                </Col>
                <Divider />
                <Col span={24} md={24} lg={12}>
                    <Row style={{flexDirection: "column", marginBottom: "16px"}}>
                        <h3>Diğer Bilgiler</h3>
                        <Descriptions
                            bordered
                            size={"small"}
                            column={1}
                            className="courierSummaryDescriptions"
                        >
                            <Descriptions.Item label={t("fields.testUser", {ns: "common"})}>
                                {isTestUser
                                    ? t("other.yes", {ns: "common"})
                                    : t("other.no", {ns: "common"})}
                            </Descriptions.Item>
                            <Descriptions.Item label={t("fields.drivingTraining", {ns: "common"})}>
                                {trained
                                    ? t("other.yes", {ns: "common"})
                                    : t("other.no", {ns: "common"})}
                            </Descriptions.Item>
                            <Descriptions.Item label={t("fields.vehicleInfo", {ns: "common"})}>
                                {vehicleInfo}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={`${t("courierPageFields.seniority", {
                                    ns: "courierPage"
                                })}(${t("units.month.long", {ns: "common"})})`}
                            >
                                {courierSeniority(jobStartDate)}
                            </Descriptions.Item>
                            <Descriptions.Item label={t("fields.createdBy", {ns: "common"})}>
                                {(createdById ? createdByUser?.fullName : createdBy) ||
                                    `${fullname} (Başvuru Yapan)` ||
                                    "-"}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.courierCreatedAt", {ns: "courierDetail"})}
                            >
                                {createdAt ? moment(createdAt).format("DD-MM-YYYY hh:mm:ss") : "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label={t("fields.updatedBy", {ns: "common"})}>
                                {updatedBy || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.courierUpdatedAt", {ns: "courierDetail"})}
                            >
                                {updatedAt ? moment(updatedAt).format("DD-MM-YYYY hh:mm:ss") : "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Arkadaşını Getir Ref. Kod">
                                <span data-testid="courierVGID">{vgid || "-"}</span>
                            </Descriptions.Item>
                        </Descriptions>
                    </Row>
                </Col>
                <Col span={24} md={24} lg={12}>
                    <Row style={{flexDirection: "column", marginBottom: "16px"}}>
                        <h3>Mobil Cihaz Bilgileri</h3>
                        <Descriptions
                            bordered
                            size={"small"}
                            column={1}
                            className="courierSummaryDescriptions"
                        >
                            <Descriptions.Item
                                label={t("fields.deviceInformation", {ns: "courierDetail"})}
                            >
                                {deviceInfo?.device || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.operatingSystem", {ns: "courierDetail"})}
                            >
                                {deviceInfo?.os || "-"}
                            </Descriptions.Item>
                        </Descriptions>
                    </Row>
                </Col>
            </Row>
        </>
    );
};
